import { Component } from '@angular/core';
import { IconComponent, SectionLinkDirective } from '../../shared';
import { HERO } from '../../content/home.content';

@Component({
  selector: 'app-hero',
  imports: [IconComponent, SectionLinkDirective],
  templateUrl: './hero.component.html'
})
export class HeroComponent {
  readonly content = HERO;
}
